// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./fleet-anchor-lines-container\"></require>\n  <fleet-anchor-lines-container\n    if.bind=\"data.productionOrderId > 0\"\n    production-order-id.bind=\"data.productionOrderId\"\n  ></fleet-anchor-lines-container>\n</template>\n";
// Exports
export default code;